export default "__VITE_ASSET__mqv6IvEF__"